import BaruDashboard from './routes/baru_dashboard/BaruDashboard.vue';

import BaruManageAccount from './routes/baru_manage_account/BaruManageAccount.vue';

import BaruManageMember from './routes/baru_manage_member/BaruManageMember.vue';


const ProgramBaruRoutes = [
  {
    path: '/baru-dashboard',
    name: 'BaruDashboard',
    component: BaruDashboard,
  },
  {
    path: '/baru-manage-account',
    name: 'BaruManageAccount',
    component: BaruManageAccount,
  },
  {
    path: '/baru-manage-member',
    name: 'BaruManageMember',
    component: BaruManageMember,
  },
];

export default ProgramBaruRoutes;
